module.exports = __webpack_public_path__ + "static/media/overlake.3499bf35.jpeg";